import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
const LANDSCAPE_BASE_URL = process.env.LANDSCAPE_BASE_URL;

export const B12Landscape= () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${LANDSCAPE_BASE_URL}/content/index.js`;
    script.type = 'module';
    script.crossOrigin = 'anonymous';

    const siemensLandscapeDiv = document.getElementById('siemens-landscape');
    siemensLandscapeDiv?.appendChild(script);

    return () => {
      if (siemensLandscapeDiv?.contains(script)) {
        siemensLandscapeDiv.removeChild(script);
      }
    };
  }, []);
  return ( <><Helmet>
       <link rel="stylesheet" crossorigin href={`${LANDSCAPE_BASE_URL}/content/styles/index.css`} />





</Helmet>
<div className="preview-container">
      <div className="preview-wrapper">
        <div id="siemens-landscape"></div>
      </div>
    </div></>
  )
}
{/* <Helmet>
      {pageTitle ? <title>{pageTitle}</title> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Siemens" /> <script type="module" crossorigin src="/assets/landscape/assets/index-P1XDtQpz.js"></script>
    <link rel="stylesheet" crossorigin href="/assets/landscape/assets/index-HUOhO59v.css">

      <meta name="twitter:url" content={origin} />

      {pageTitle ? <meta property="og:title" content={pageTitle} /> : null}

      {pageTitle ? <meta property="twitter:title" content={pageTitle || ''} /> : null}

      {pageDesc ? <meta property="og:description" content={pageDesc || ''} /> : null}
      {pageDesc ? <meta property="twitter:description" content={pageDesc || ''} /> : null}

      {pageImage ? <meta property="og:image" content={pageImage} /> : null}
      {pageImage ? <meta property="twitter:image" content={pageImage} /> : null}
    </Helmet> */}